<div class="container">
    <div class="search-input">
        <div class="control">
            <mat-form-field class="search">
              <input autocomplete="off" matInput placeholder="Search for a sites" [(ngModel)]="searchField" (ngModelChange)="onSearchTextChange($event)">
              <mat-icon matPrefix>search</mat-icon>
            </mat-form-field>
          </div>
    </div>
    <div class="table-container">
      <nrwl-view-table [dataSource]="dataSource"
      [defaultPageSize]="pageSize"
      [defaultPageSizeOptions]="pageSizeOptions"
      [paginatorOptions]="showPaginator"
      [selectedRowIndex]="selectedRowIndex"
      [options]="tableOptions"> </nrwl-view-table>
    </div>
</div>
